import React, { useState, useEffect } from "react";

import "./Privacy.css";
import { api_call } from "../../utils/Network";

function PrivacyPolicy() {
  const [displayData, setDisplayData] = useState({ point: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    api_call
      .get(`service_list/terms_data/PrivacyPolicy/info/`)
      .then((response) => {
        setDisplayData(response.data.data);
      });
  };

  return (
    <div className="main_terms">
      <h2>{displayData.title}</h2>
      <div
        dangerouslySetInnerHTML={{ __html: `${displayData.point}` }}
        className="Trms"
      ></div>
    </div>
  );
}

export default PrivacyPolicy;
